// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdateJobSubComponentMutation($input: UpdateJobSubComponentInput!) {
    updateJobSubComponent(input: $input) {
      jobEdge {
        ...JobsTable_jobEdges
        node {
          ...JobSubComponents_job
          id
          importJobNumber
          jobNumber
          name
          status
          subComponents(first: null) {
            edges {
              usageQty
              node {
                id
                itemNumber
                name
                upc
                partNumber
                description
                category {
                  id
                  name
                }
                quantityUOM {
                  id
                  name
                  type
                  symbol
                }
                weightUOM {
                  id
                  name
                  type
                  symbol
                }
                dimensionUOM {
                  id
                  name
                  type
                  symbol
                }
                formFieldValues
                dimensionLength
                dimensionWidth
                dimensionHeight
                weight
              }
            }
          }
          user {
            id
            firstName
            lastName
          }
          order {
            id
            promisedAt
            orderNumber
            status
            customer {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
